export const ROLES = {
  MANAGER: { value: "MANAGER", label: "Manager" },
  DISTRIBUTOR: { value: "DISTRIBUTOR", label: "Distribuidor" },
};
